import React from 'react';
import { Container, Row, Spinner } from "reactstrap";

type LoadingInPogressProps = {
    message: string
}

/**
 * LoadingInProgress displays a spinner and a message to indicate that a process is in progress.
 * 
 * @param props: {message} 
 * @returns 
 */
const LoadingInPogress = (props: LoadingInPogressProps) => (
  <div className="text-center">
    <Container fluid className="vh-50 d-flex">
        <Row className="justify-content-center align-self-center w-100 text-center">
            <Spinner color="primary" />
            <h6>{props.message}</h6>
        </Row>
    </Container>
  </div>  
);

export default LoadingInPogress;
